import AbstractAction from "../AbstractAction";

export default class CopyAppearanceAction extends AbstractAction {
    constructor(provider, element, appearance) {
        super(provider);

        this.element = element;
        this.newAppearance = appearance.clone();
        this.oldAppearance = element.appearance.clone();

    }

    finish() {
        this.element.appearance = this.newAppearance;
        this.newAppearance.setParent(this.element);
        this.oldAppearance.setParent(undefined);
        this.element.row.updateImg();
        super.finish();
    }

    undo() {
        this.element.appearance = this.oldAppearance;
        this.oldAppearance.setParent(this.element);
        this.newAppearance.setParent(undefined);
        this.element.row.updateImg();
    }

    redo() {
        this.element.appearance = this.newAppearance;
        this.newAppearance.setParent(this.element);
        this.oldAppearance.setParent(undefined);
        this.element.row.updateImg();
    }
}
